import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateEventDTO, EventsApiService } from 'features/events';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createEvent } = EventsApiService();

export const useCreateEvent = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateEventDTO) => {
      return createEvent(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
        message.success(i18n.t('events.create.successfulCreate'));
      },
    },
  );
};
